module.exports = __webpack_public_path__ + "static/media/register.fd7cb034.png";